import React, { useEffect ,useLayoutEffect} from "react";
import { Image } from '../atoms/image';
import { Label } from "../atoms/label";
import { Address } from "../molecules/address";
import { Line } from "../atoms/line";
import { PlanSetForm } from "../molecules/planSetForm";
import GolfSearchResultsDetailContainer from "../organisms/golfSearchResultsDetailContainer";
import useMedia from 'use-media';
import { useState } from 'react'
import { useHistory } from "react-router-dom";
import { connect ,useStore} from "react-redux";
import img_top from '../../resources/icons/ico_arrow_top.svg';
import img_bottom from '../../resources/icons/ico_arrow_bottom.svg';
import { CourseCount } from '../atoms/courseCount';
import { PullDown } from "../atoms/pullDown";
import image_List from '../../resources/icons/ico_list.svg';
import image_Pulldown from '../../resources/icons/arw_pulldown.svg';
import common from "../../resources/js/common/common";
import { versionGetApi } from "../../const";
import { apiKeyCheck } from "../../const";
import "../../resources/css/search/search.css";
import { useRtoaster } from "../../hooks/useRtoaster";
const GolfPlanContainer = (props) => {
  const { searchResult, setPlan, setFacility, setCourseNames, playDate1, group, course,kaiinken,setGolfLocation } = props;

  const [result, setResult] = useState([]);
  const [defaultResult, setDefaultResult] = useState([]);
  const [courseNameReal, setCourseNameReal] = useState([]);
  const [courseNameDefault, setCourseNameDefault] = useState([]);
  const [courseCount, setCourseCount] = useState(0);
  const [parent, setParent] = useState(0);
  const [children, setChildren] = useState(0);
  const [defaultPlan, setDefaultPlan] = useState([]);
  const [realPlan, setRealPlan] = useState([]);
  const [realPlanNum, setRealPlanNum] = useState([]);
  const [planDetailParentIdx, setPlanDetailParentIdx] = useState(null);
  const [planDetailIdx, setPlanDetailIdx] = useState(null);
  const [detailPlanType, setDetailPlanType] = useState(null);
  const [kaiinkenShisetuCd, setKaiinkenShisetuCd] = useState(null);
  const store = useStore();

  const history = useHistory();
  const sortList = [
    { option: "価格 安い順" }, { option: "価格 高い順" },
  ]
  const [listFlg, setListFlg] = useState([]);

  useLayoutEffect(() => {
    // リフレッシュ対応
      let state = store.getState().login;
      let apiKey = null;
      if(Object.keys(state).length !== 0){   
          apiKey = state.apiKey;
      }
      if(apiKey === null){
          store.dispatch({ type: "CLEAR_STATE"});
          history.push("/reserve/login");
      }
      if(apiKey){
      common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
      }
  })
  const afterApiKeyCheck = (res) => {
      if(!res.data){
          console.log("バックからの戻り値false");
          store.dispatch({ type: "CLEAR_STATE"});
          history.push("/reserve/login");
      }
  }

  // rtoasterタグ生成
  const partyCount = group?.find(value => value.selected)?.id;
  let contractNo = "";
  kaiinken.forEach((data) => {
    if (data.selected === true) {
      contractNo = data.contractNo;
    }
  });
  const riyoDate = new Date(playDate1);
  const customParam = {
    "sisetucd": course.filter(value => value.checked)?.map(value => { return value.facilityCd })?.join(","),
    "riyodat": `${riyoDate.getFullYear()}-${(riyoDate.getMonth() + 1).toString().padStart(2, "0")}-${(riyoDate.getDate()).toString().padStart(2, "0")}`,
    "keiyakuno": contractNo,
    "kumisu": partyCount ? Number(partyCount) : 1,
  }
  useRtoaster(history.location.pathname, customParam);

  // プラン情報取得
  useEffect(() => {
    setGolfLocation("");
    common.doPost(versionGetApi, {}, afterVerCheck);

    kaiinken.forEach((data) => {
      if (data.selected === true) {
          console.log("会員権種別コード取得："+data.facilityCd);
          setKaiinkenShisetuCd(data.facilityCd);
      }
  });
    if (searchResult.golfCourses !== undefined) {

      var golfCourses = JSON.parse(JSON.stringify(searchResult.golfCourses));
      var golfDefaultCourses = JSON.parse(JSON.stringify(searchResult.golfCourses));
      let courseNamesReal = {};
      let realPlanList = [];
      let realPlanListNum = [];
      let clickFlg = {};
      golfCourses.forEach((golfCourse,index)=>{
        clickFlg[index] = false;
        let courseNames = [];
        const plans=golfCourse.plans
        plans.forEach((plan,index)=>{
            const plansets = plan.plansets
            plansets.forEach((planset)=>{
                let playdates = planset.playdates
                playdates.forEach((playdate)=>{
                    let courses = playdate.courses;
                    let pops = [];
                    courses.forEach((course, idx)=>{
                        const teetimes = course.teetimes;
                        course.teetimes = teetimes.filter((teetime)=>{
                            return teetime.type === "real";
                        })
                        if(course.teetimes.length === 0){
                          pops.push(idx);
                        }
                        else if(!courseNames.includes(course.courseName)){
                          courseNames.push(course.courseName);
                        }
                    })
                    courses = courses.filter((course, idx)=>{
                      return !pops.includes(idx);
                    })
                    playdate.courses = courses;
                })
                planset.playdates = playdates.filter((course, idx)=>{
                  return !course.courses.length == 0;
                })
            })
            plan.plansets = plansets.filter((planset, idx)=>{
              return !planset.playdates.length == 0;
            })
        })
        golfCourse.plans = plans.filter((plan, idx)=>{
          return !plan.plansets.length == 0;
        })
        // if(golfCourse.plans.length != 0){
          realPlanListNum.push(golfCourse.plans.length);
        // }
        realPlanList.push(golfCourse.plans);
        var courseNameList = JSON.parse(JSON.stringify(courseNames));
        let key = index;
        courseNamesReal[key] = courseNameList;
      })

      setRealPlan(realPlanList);
      setRealPlanNum(realPlanListNum);
      let courseNamesDefault = {};
      let defaultPlanList = [];
      golfDefaultCourses.forEach((defaultGolfCourse ,index)=>{
        const defaultPlanname = defaultGolfCourse.plans;
        defaultGolfCourse.plans = defaultPlanname.filter((planname) =>{
          if (planname.planname === "１人予約"){
            return planname.planname === "１人予約";
          } else if(planname.planname === "キャンセル待ち予約"){
            return planname.planname === "キャンセル待ち予約";
          }
        })
        let defaultCourseNames = [];
        const defaultPlans=defaultGolfCourse.plans
        defaultPlans.forEach((defaultPlan)=>{
            const defaultPlansets = defaultPlan.plansets
            defaultPlansets.forEach((defaultPlanset)=>{
                let defaultPlaydates = defaultPlanset.playdates
                defaultPlaydates.forEach((defaultPlaydate)=>{
                    let defaultCourses = defaultPlaydate.courses;
                    let pops = [];
                    defaultCourses.forEach((defaultCourse, idx)=>{
                        const defaultTeetimes = defaultCourse.teetimes;
                        defaultCourse.teetimes = defaultTeetimes.filter((teetime)=>{
                            return teetime.type === "request";
                        })
                        if(defaultCourse.teetimes.length === 0){
                          pops.push(idx);
                        }
                        else if(!defaultCourseNames.includes(defaultCourse.courseName)){
                          defaultCourseNames.push(defaultCourse.courseName);
                        }
                    })
                    defaultCourses = defaultCourses.filter((course, idx)=>{
                      return !pops.includes(idx);
                    })
                    defaultPlaydate.courses = defaultCourses;
                })
                defaultPlanset.playdates = defaultPlaydates.filter((course, idx)=>{
                  return !course.courses.length == 0;
                })
            })
            defaultPlan.plansets = defaultPlansets.filter((planset, idx)=>{
              return !planset.playdates.length == 0;
            })
        })
        defaultGolfCourse.plans = defaultPlans.filter((plan, idx)=>{
          return !plan.plansets.length == 0;
        })
        defaultPlanList.push(defaultGolfCourse.plans);
        var defaultCourseNameList = JSON.parse(JSON.stringify(defaultCourseNames));
        let key = index;
        courseNamesDefault[key] = defaultCourseNameList;
      })

      //該当コースカウント
      let courseCountObj = [];
      defaultPlanList.forEach((data,index)=>{
        if(data.length !== 0){
          courseCountObj[index] = true
        }
        else{
          courseCountObj[index] = false
        }
      })
      let courseCount = 0;
      realPlanList.forEach((data,index)=>{
        if(!courseCountObj[index]){
          if(data.length !== 0){
            courseCountObj[index] = true
          }
        }
        if(courseCountObj[index]){
          courseCount += 1;
        }
      })
      
      setDefaultPlan(defaultPlanList);
      setListFlg(clickFlg);
      // setCourseNames(defaultCourseNames);
      setCourseNameDefault(courseNamesDefault)
      setCourseNameReal(courseNamesReal);
      setResult(golfCourses);
      setDefaultResult(golfDefaultCourses);
      setCourseCount(courseCount);
    }else{
      setCourseNames([]);
      setResult([]);
      setCourseCount(0);
    }
  }, [searchResult]);

  const afterVerCheck = (res) => {
    let flg = common.versionCheck(res.data.version);
    if(flg){
        history.push("/reserve/login");
        return;
    }
}

  //レスポンシブ対応
  const isWidePhone = useMedia({ maxWidth: '480px' });
  const isWideTablet = useMedia({ maxWidth: '960px' });
  const [Phone, setPhone] = useState(false);
  const [Tablet, setTablet] = useState(false);
  useEffect(() => {
    if (isWideTablet && isWidePhone) {
      setPhone(true);
      setTablet(false);
    }
    else if (isWideTablet && !isWidePhone) {
      setPhone(false);
      setTablet(true);
    }
    else if (!isWideTablet && isWidePhone) {
      setTablet(false);
      setPhone(true);
    }
    else {
      setPhone(false);
      setTablet(false);
    }
  })
  //state
  const [popFlg, setPopFlg] = useState(false);
  const DetailClick = (parentIndex, index,planType) => {
    
    setPlanDetailParentIdx(parentIndex);
    setPlanDetailIdx(index);
    if(planType === "real"){
      setFacility(result[parentIndex]);
      setPlan(result[parentIndex].plans[index]);
    }
    if(planType === "request"){
      setFacility(defaultResult[parentIndex]);
      setPlan(defaultResult[parentIndex].plans[index]);
    }
    setDetailPlanType(planType);
    setParent(parentIndex);
    setChildren(index);

    //プラン詳細押下時の処理(ポップアップ表示)
    setPopFlg(true);
  };
  const PlanListClick = (index) => {
    // 押下時の処理(ポップアップ表示)
    console.log(listFlg);
    listFlg[index] = !listFlg[index];
    let flg = Object.assign({}, listFlg); 
    setListFlg(flg);
  };

  const defaultCnt = (plan) => {
    let ret = 0;
    if (plan != undefined && plan.plansets != undefined) {
      const planset2 = plan.plansets.map(planset => {
        const playdate2 = planset.playdates.map(playdate => {
          const course2 = playdate.courses.map(course => {
            const teetime2 = course.teetimes.map((teetime) => {
              if (teetime.type === "request") {
                ret = 1;
              }
              return teetime;
            })
            return teetime2;
          })
          return course2;
        })
        return playdate2;
      })
    }
    return ret;
  }
  const defaultPlanIdCheck = (defaultPlanInfo,data) => {
      let flg = false;
      data.plans.map((plan, index2) => {
        if(flg == false){
          if (plan != undefined && defaultPlanInfo != undefined) {
            if(plan.planid == defaultPlanInfo.planid){
              flg = true;
            }
          }
        }
      })
    return flg;
  }
  const realPlanIdCheck = (defaultPlanInfo , data) => {
      let flg = false;
      data.plans.map((plan, index2) => {
        if(flg == false){
          if (plan != undefined && defaultPlanInfo != undefined) {
            if(plan.planid == defaultPlanInfo.planid){
              flg = true
            }
          }
        }
      })
    return flg
  }
  const normalCnt = (plan) => {
    let ret = 0;
    if (plan != undefined && plan.plansets != undefined) {
      const planset2 = plan.plansets.map(planset => {
        const playdate2 = planset.playdates.map(playdate => {
          const course2 = playdate.courses.map(course => {
            const teetime2 = course.teetimes.map((teetime) => {
              if (teetime.type == undefined
                || teetime.type === "real") {
                ret = 1;
              }
              return teetime;
            })
            return teetime2;
          })
          return course2;
        })
        return playdate2;
      })
    }
    return ret;
  }

  const defaultPlanCnt = (plans) => {
    const cnt = plans.map((plan) => {
      return defaultCnt(plan);
    });
    let total = cnt.reduce(function (sum, element) {
      return sum + element;
    }, 0);
    return total;
  }

  const normalPlanCnt = (plans) => {
    const cnt = plans.map((plan) => {
      return normalCnt(plan);
    });
    let total = cnt.reduce(function (sum, element) {
      return sum + element;
    }, 0);
    return total;
  }
  // ソートメソッドを定義
  const handleSort = (event) => {

    // result.plans.plansetsのpriceTotalで昇順に並び替える
    const result_data = result.map((result_output, result_index) => {
      const plans_data = result_output.plans.map((plans_output, plans_index) => {
        plans_output.plansets = plans_output.plansets.sort((a, b) => {
          if (a.priceTotal < b.priceTotal) return -1;
          if (a.priceTotal > b.priceTotal) return 1;
          return 0;
        });
        return plans_output;
      });
      return plans_data;
    });

    result.plans = result_data;
    const sort = (event.target.value == "価格 安い順" ? -1 : 1)

    // 最安値を比較して並び替える
    const result_data_sort = result.map((result_output, result_index) => {
      let data = result_output;
      data.plans = data.plans.sort((a, b) => {
        if (normalCnt(a) <= 0) return 0;
        if (a.plansets[0].priceTotal < b.plansets[0].priceTotal) return sort;
        if (a.plansets[0].priceTotal > b.plansets[0].priceTotal) return (sort * -1);
        return 0;
      });
      return data;
    });
    setResult(result_data_sort);
    return result_data_sort;
  };

  // 画面遷移
  const onClickNext = (parentIndex, index, planInfo) => {
    if(planInfo == "request"){
      if (defaultResult[parentIndex] != undefined) {
      setFacility(defaultResult[parentIndex]);
      setPlan(defaultResult[parentIndex].plans[index]);
      setCourseNames(courseNameDefault[parentIndex]);
      }
      store.dispatch({ type:"RESERVE_TYPE", payload: { reserveType:"request"} });
    }
    if(planInfo == "real"){
      if (result[parentIndex] != undefined) {
        setFacility(result[parentIndex]);
        setPlan(result[parentIndex].plans[index]);
        setCourseNames(courseNameReal[parentIndex]);
        console.log("test");
      }
      store.dispatch({ type:"RESERVE_TYPE", payload: { reserveType:"real"} });
    }
    history.push("/reserve/golf/startTime");
  };

  return (
    <div style={Phone ? styles.golfPlanSp : styles.golfPlan}>
      {popFlg ?
        <GolfSearchResultsDetailContainer
          setState={setPopFlg} 
          onClick={onClickNext}
          detailPlanType={detailPlanType}
          parentIndex={planDetailParentIdx}
          index={planDetailIdx}
          kaiinken={kaiinkenShisetuCd}
        />
        :
        null
      }

      <div style={Phone ? styles.golfPlanMainSp : styles.golfPlanMain}>
        <div style={Phone ? styles.topSP : styles.top}>
          <div style={Phone ? styles.counseCountSP : styles.counseCount}>
            <CourseCount course={courseCount} spanClass={"courseCountSpan"} />
          </div>
          {/* <div style={Phone ? styles.pullSP : styles.pull}>
            <PullDown data={sortList} selectStyle={styles.selectStyle} onChange={(e) => { handleSort(e) }} />
          </div> */}
        </div>
        {searchResult.length == 0 ?
        <div style={{marginTop:30,textAlign:"center",color:"red",background:"none"}}>条件に一致するプランがありません</div>
        :null}
        {searchResult.golfCourses ? searchResult.golfCourses.map((data, index) => {
          let parentIndex = index;
          let idx = -1;
          let defaultIdx = -1;
          return (
            <>
              {/* <div style={(defaultPlanCnt(data.plans) + normalPlanCnt(data.plans) == 0) ? styles.none : styles.box}> */}
              <div style={(defaultPlan[parentIndex] !== undefined && realPlan[parentIndex] !== undefined ? 
                  data.plans.length == 0 || (defaultPlan[parentIndex].length === 0 && realPlan[parentIndex].length === 0) 
                  ? styles.none : styles.box : styles.none)}>
                <Image image={`${data.image_path} `} style={styles.image} />
                <div style={styles.planBody}>
                  <Label label={data.name} style={styles.planName} />
                  <Address kindCar={false} text={`〒${data.zip} ${data.address}`} style={styles.address} />
                  <Address kindCar={true} text={data.access_car} />
                </div>
                <Line style={styles.hereLine} />
                <div style={styles.planBody}>
                {defaultPlan[parentIndex] !== undefined ? (defaultPlan[parentIndex].length > 0) ? 
                <Label label="デフォルトプラン" style={styles.planCount} /> 
                  : "" : ""}
                  <div style={defaultPlan[parentIndex] !== undefined ? (defaultPlan[parentIndex].length > 0) ? styles.defaultBody:{display:"none"}:{display:"none"}}>
                    {/* {data.plans.map((plan, index) => { */}
                    {defaultPlan[parentIndex] !== undefined ? defaultPlan[parentIndex].length !== 0 ? 
                        defaultPlan[parentIndex].map((plan,index) => { 
                        let defaultPrice = plan.plansets[0].priceTotal;
                        plan.plansets.forEach((planset) => {
                          defaultPrice = defaultPrice <= planset.priceTotal ? defaultPrice : planset.priceTotal
                        });
                        if (defaultPlanIdCheck(plan,data)) {
                          defaultIdx = defaultIdx + 1;
                          return (
                            <>
                                <PlanSetForm
                                key={plan.planId}
                                paretnIndex={parentIndex}
                                index={defaultIdx}
                                title={plan.planname}
                                memberPrice={defaultPrice}
                                //guestPrice={plan.guestPrice}
                                clickDetail={DetailClick}
                                onClick={onClickNext} 
                                planType={"request"}
                                priceDispFlg={data.golfCourseID === kaiinkenShisetuCd ? true : false}
                                />
                              {/* {defaultPlan[parentIndex] !== undefined ? defaultPlan[parentIndex].length < 2 || defaultPlan[parentIndex].length == index+1 ? "" : <Line style={styles.defaultLine} /> : ""} */}
                            </>
                          );
                        }
                    }):null:null}
                  </div>
                  {realPlan[parentIndex] !== undefined ? realPlan[parentIndex].length == 0 ? "" :
                    <Label label={"プラン一覧（" + realPlanNum[index] + "件）"} style={styles.planCount} />
                    :""
                  }
                  <div style={realPlan.length == 0 || realPlanNum[index] < 1 ? styles.none : styles.planListStyle}>
                    {realPlan[parentIndex] !== undefined ? realPlan[parentIndex].length !== 0 ? 
                      realPlan[parentIndex].map((plan, index) => {
                      let price = plan.plansets[0].priceTotal;
                      plan.plansets.forEach((planset) => {
                        price = price <= planset.priceTotal ? price : planset.priceTotal
                      });
                      // if (normalCnt(plan) == "1") {
                        if (realPlanIdCheck(plan,data)) {
                          idx = idx+1
                        return (
                          (listFlg[parentIndex] || idx < 2) ?
                            <>
                              <PlanSetForm
                                key={plan.planId}
                                paretnIndex={parentIndex}
                                index={idx}
                                title={plan.planname}
                                memberPrice={price}
                                //guestPrice={plan.guestPrice}
                                clickDetail={DetailClick}
                                onClick={onClickNext} 
                                planType={"real"}
                                priceDispFlg={data.golfCourseID === kaiinkenShisetuCd ? true : false}
                                />
                              {/* {index === normalPlanCnt(data.plans) - 1 ? null : <Line style={styles.lineStyle} />} */}
                            </>
                            : null
                        );
                      }
                    }):null:null}
                  </div>
                  <div onClick={() =>PlanListClick(parentIndex)} style={realPlanNum[index] <= 2 ? styles.planNotShow : styles.planShow} >
                    <Label label={listFlg[parentIndex] ? "プランを隠す" : "すべてのプランを見る"} style={styles.listShow} />
                    <Image image={listFlg[parentIndex] ? img_top : img_bottom} style={styles.iconShow} />
                  </div>
                </div>
              </div>
            </>
          )
        }) : null}
      </div>
    </div>
  )
}

const styles = {
  defaultLine: {
    // marginLeft: "30px",
    // marginRight: "30px",
    margin: "10px 0px 30px"
  },
  golfPlan: {
    width: "50%",
    display: "inline-block",
    textAlign: "left",
  },
  golfPlanSp: {
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "left",
  },
  golfPlanMain: {
    marginLeft: "5%",
    marginRight: "0%",
  },
  golfPlanMainSp: {
    backgroundColor: "white",
    fontSize: "80%",
  },
  top: {
    backgroundColor: "#F5F5F5",
  },
  topSP: {
    backgroundColor: "#F5F5F5",
  },
  counseCount: {
    display: "inline-block",
  },
  counseCountSP: {
    display: "inline-block",
    marginLeft: "5%",
    marginBottom: "0px",
  },
  pull: {
    display: "inline-block",
    float: "right",
    marginTop: "20px",
    cursor: "pointer",
  },
  pullSP: {
    display: "inline-block",
    float: "right",
    marginRight: "5%",
    cursor: "pointer",
  },
  address: {
    marginBottom: "10px",
  },
  selectStyle: {
    float: "right",
    width: "160px",
    height: "40px",
    backgroundImage: `url(${image_List}),url(${image_Pulldown})`,
    backgroundSize: "20px 15px, 25px ",
    backgroundPosition: "left 5px center,right center",
    backgroundRepeat: "no-repeat",
    webkitAppearance: "none",
    paddingLeft: "30px",
    //direction: "rtl",
    direction: "unset",
    fontSize: "small",
    cursor: "pointer",
    marginLeft: "5px",
  },
  box: {
    backgroundColor: "white",
    marginBottom: "70px",
  },
  image: {
    width: "100%",
  },
  planBody: {
    margin: "20px 20px 0px",
    paddingBottom: "20px",
  },
  defaultBody: {
    // backgroundColor: "rgb(247, 247, 247)",
    // padding:"30px 20px"
  },
  planName: {
    fontSize: "1.4rem",
    marginBottom: "20px",
  },
  detailHere: {
    textAlign: "right",
    fontSize: "1rem",
    fontWeight: "bold",
    textDecoration: "underline",
    display: "block",
    color: "black",
    cursor: "pointer",
    marginTop: "30px",
  },
  hereLine: {
    border: "1px solid rgb(204, 204, 204)",
    borderWidth: "1px 0px 0px 0px",
    margin: "25px auto 0px",
  },
  planListStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    // backgroundColor: "#f7f7f7",
    // padding: "30px 20px",
  },
  planCount: {
    textAlign: "left",
    fontSize: "1rem",
    color: "#999999",
    // fontWeight: "bold",
    marginBottom: "10px"
  },
  planShow: {
    textAlign: "center",
    margin: "10px",
    cursor: "pointer",
  },
  planNotShow: {
    display: "none",
  },
  listShow: {
    display: "inline-block",
    fontWeight: "bold",
  },
  iconShow: {
    display: "inline-block",
    width: "1rem",
    marginLeft: "1rem",
  },
  none: {
    display: "none",
  },
  lineStyle: {
    border: "1px solid rgb(204, 204, 204)",
    borderWidth: "1px 0px 0px 0px",
    margin: "10px 0px 30px",
  },
}

const mapStateToProps = (state) => {
  return {
    searchResult : state.searchResult,
    course : state.course,
    group : state.group,
    playDate1 : state.playDate1,
    kaiinken:state.kaiinken
  };
};

const mapToDispatchToProps = (dispatch) => {
  return {
    setFacility: (item) => {
      dispatch({ type: "SET_FACILITY", payload: { facility: item } })
    },
    setPlan: (item) => {
      dispatch({ type: "SET_PLAN", payload: { plan: item } })
    },
    setCourseNames: (item) => {
      dispatch({ type:"SET_COURSE_NAMES", payload: { courseNames: item } })
    },    
    setGolfLocation: (item) => {
      dispatch({ type: "GOLF_LOCATION", payload: { golfLocation: item} })
  },
  };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfPlanContainer);
